<template>
  <snippet-medium
    :document="mutatedData"
    :label="data.organization"
    cssClass="snippet_checklist"
  >
    <template v-slot:after>
      <button
        class="button _small"
        :class="{ _cancel: selected }"
        @click="onSelectClick"
      >
        {{ selected ? 'Отменить выбор' : 'Выбрать' }}
      </button>
    </template>
  </snippet-medium>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import DocumentRoute from '@@/document/mixins/DocumentRoute';
import SnippetMedium from '@@/shared/snippets/Snippet_Medium';

export default {
  components: {
    SnippetMedium
  },

  mixins: [DocumentRoute],

  props: {
    /** @type {Object|ApiDocumentSearchCardDef} */
    data: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapState(['documentStatuses']),
    ...mapGetters(['selectedChecklists']),

    statusIcon() {
      return this.documentStatuses[this.data.statusId].icon;
    },

    selected() {
      const arr = this.selectedChecklists.map(item => item.id);

      return arr.indexOf(this.data.id) > -1;
    },

    designation() {
      let type = this.data.type;
      let number = this.data.number;

      return type + (type && number ? ' ' : '') + number;
    },

    // TODO: this must be solved by api or vuex
    mutatedData() {
      this.data.statusDate = this.data.approvalDate;
      return this.data;
    }
  },

  methods: {
    onSelectClick() {
      const mode = !this.selected ? 'add' : 'remove';

      this.$store.dispatch('changeChecklistsQuery', {
        mode: mode,
        value: {
          id: this.data.id,
          title: this.data.title
        }
      });
    }
  }
};
</script>
